// Grouped client for Fcb2B operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { DataFormActionRequest } from '../models/DataFormActionRequest';
import { DataFormActionResponse } from '../models/DataFormActionResponse';
import { BomKit } from '../models/BomKit';
import { UpdateBomKitRequest } from '../models/UpdateBomKitRequest';
import { CreateBomKitRequest } from '../models/CreateBomKitRequest';
import { BomKitFields } from '../models/BomKitFields';
import { FilterBomKitRequest } from '../models/FilterBomKitRequest';
import { DataviewBomKitResponse } from '../models/DataviewBomKitResponse';
import { BomKitItem } from '../models/BomKitItem';
import { UpdateBomKitItemRequest } from '../models/UpdateBomKitItemRequest';
import { CreateBomKitItemRequest } from '../models/CreateBomKitItemRequest';
import { BomKitItemFields } from '../models/BomKitItemFields';
import { FilterBomKitItemRequest } from '../models/FilterBomKitItemRequest';
import { DataviewBomKitItemResponse } from '../models/DataviewBomKitItemResponse';
import { EstimateOptions } from '../models/EstimateOptions';
import { FilterEstimateOptionsRequest } from '../models/FilterEstimateOptionsRequest';
import { DataviewEstimateOptionsResponse } from '../models/DataviewEstimateOptionsResponse';
import { InstallationTypeOption } from '../models/InstallationTypeOption';
import { FilterInstallationTypeOptionRequest } from '../models/FilterInstallationTypeOptionRequest';
import { DataviewInstallationTypeOptionResponse } from '../models/DataviewInstallationTypeOptionResponse';
import { PatternTypeOption } from '../models/PatternTypeOption';
import { FilterPatternTypeOptionRequest } from '../models/FilterPatternTypeOptionRequest';
import { DataviewPatternTypeOptionResponse } from '../models/DataviewPatternTypeOptionResponse';
import { PaymentTerms } from '../models/PaymentTerms';
import { UpdatePaymentTermsRequest } from '../models/UpdatePaymentTermsRequest';
import { CreatePaymentTermsRequest } from '../models/CreatePaymentTermsRequest';
import { PaymentTermsFields } from '../models/PaymentTermsFields';
import { FilterPaymentTermsRequest } from '../models/FilterPaymentTermsRequest';
import { DataviewPaymentTermsResponse } from '../models/DataviewPaymentTermsResponse';
import { PickList } from '../models/PickList';
import { UpdatePickListRequest } from '../models/UpdatePickListRequest';
import { CreatePickListRequest } from '../models/CreatePickListRequest';
import { PickListFields } from '../models/PickListFields';
import { FilterPickListRequest } from '../models/FilterPickListRequest';
import { DataviewPickListResponse } from '../models/DataviewPickListResponse';
import { PickListItem } from '../models/PickListItem';
import { UpdatePickListItemRequest } from '../models/UpdatePickListItemRequest';
import { CreatePickListItemRequest } from '../models/CreatePickListItemRequest';
import { PickListItemFields } from '../models/PickListItemFields';
import { FilterPickListItemRequest } from '../models/FilterPickListItemRequest';
import { DataviewPickListItemResponse } from '../models/DataviewPickListItemResponse';
import { Fcb2BProductTypeOption } from '../models/Fcb2BProductTypeOption';
import { FilterFcb2BProductTypeOptionRequest } from '../models/FilterFcb2BProductTypeOptionRequest';
import { DataviewFcb2BProductTypeOptionResponse } from '../models/DataviewFcb2BProductTypeOptionResponse';
import { StartFpRoomCreateFileRequest } from '../models/StartFpRoomCreateFileRequest';
import { StartFpRoomCreateRoomPhotoFileRequest } from '../models/StartFpRoomCreateRoomPhotoFileRequest';
import { FpRoom } from '../models/FpRoom';
import { UpdateFpRoomRequest } from '../models/UpdateFpRoomRequest';
import { CreateFpRoomRequest } from '../models/CreateFpRoomRequest';
import { FpRoomFields } from '../models/FpRoomFields';
import { FilterFpRoomRequest } from '../models/FilterFpRoomRequest';
import { DataviewFpRoomResponse } from '../models/DataviewFpRoomResponse';
import { TaxRates } from '../models/TaxRates';
import { FilterTaxRatesRequest } from '../models/FilterTaxRatesRequest';
import { DataviewTaxRatesResponse } from '../models/DataviewTaxRatesResponse';
import { Fcb2BUnderlaymentOption } from '../models/Fcb2BUnderlaymentOption';
import { FilterFcb2BUnderlaymentOptionRequest } from '../models/FilterFcb2BUnderlaymentOptionRequest';
import { DataviewFcb2BUnderlaymentOptionResponse } from '../models/DataviewFcb2BUnderlaymentOptionResponse';
import { WasteFactor } from '../models/WasteFactor';
import { UpdateWasteFactorRequest } from '../models/UpdateWasteFactorRequest';
import { CreateWasteFactorRequest } from '../models/CreateWasteFactorRequest';
import { FilterWasteFactorRequest } from '../models/FilterWasteFactorRequest';
import { DataviewWasteFactorResponse } from '../models/DataviewWasteFactorResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { DataFormActionRequestSerializer } from '../serializers/DataFormActionRequestSerializer';
import { DataFormActionResponseSerializer } from '../serializers/DataFormActionResponseSerializer';
import { BomKitSerializer } from '../serializers/BomKitSerializer';
import { UpdateBomKitRequestSerializer } from '../serializers/UpdateBomKitRequestSerializer';
import { CreateBomKitRequestSerializer } from '../serializers/CreateBomKitRequestSerializer';
import { FilterBomKitRequestSerializer } from '../serializers/FilterBomKitRequestSerializer';
import { DataviewBomKitResponseSerializer } from '../serializers/DataviewBomKitResponseSerializer';
import { BomKitItemSerializer } from '../serializers/BomKitItemSerializer';
import { UpdateBomKitItemRequestSerializer } from '../serializers/UpdateBomKitItemRequestSerializer';
import { CreateBomKitItemRequestSerializer } from '../serializers/CreateBomKitItemRequestSerializer';
import { FilterBomKitItemRequestSerializer } from '../serializers/FilterBomKitItemRequestSerializer';
import { DataviewBomKitItemResponseSerializer } from '../serializers/DataviewBomKitItemResponseSerializer';
import { EstimateOptionsSerializer } from '../serializers/EstimateOptionsSerializer';
import { FilterEstimateOptionsRequestSerializer } from '../serializers/FilterEstimateOptionsRequestSerializer';
import { DataviewEstimateOptionsResponseSerializer } from '../serializers/DataviewEstimateOptionsResponseSerializer';
import { InstallationTypeOptionSerializer } from '../serializers/InstallationTypeOptionSerializer';
import { FilterInstallationTypeOptionRequestSerializer } from '../serializers/FilterInstallationTypeOptionRequestSerializer';
import { DataviewInstallationTypeOptionResponseSerializer } from '../serializers/DataviewInstallationTypeOptionResponseSerializer';
import { PatternTypeOptionSerializer } from '../serializers/PatternTypeOptionSerializer';
import { FilterPatternTypeOptionRequestSerializer } from '../serializers/FilterPatternTypeOptionRequestSerializer';
import { DataviewPatternTypeOptionResponseSerializer } from '../serializers/DataviewPatternTypeOptionResponseSerializer';
import { PaymentTermsSerializer } from '../serializers/PaymentTermsSerializer';
import { UpdatePaymentTermsRequestSerializer } from '../serializers/UpdatePaymentTermsRequestSerializer';
import { CreatePaymentTermsRequestSerializer } from '../serializers/CreatePaymentTermsRequestSerializer';
import { FilterPaymentTermsRequestSerializer } from '../serializers/FilterPaymentTermsRequestSerializer';
import { DataviewPaymentTermsResponseSerializer } from '../serializers/DataviewPaymentTermsResponseSerializer';
import { PickListSerializer } from '../serializers/PickListSerializer';
import { UpdatePickListRequestSerializer } from '../serializers/UpdatePickListRequestSerializer';
import { CreatePickListRequestSerializer } from '../serializers/CreatePickListRequestSerializer';
import { FilterPickListRequestSerializer } from '../serializers/FilterPickListRequestSerializer';
import { DataviewPickListResponseSerializer } from '../serializers/DataviewPickListResponseSerializer';
import { PickListItemSerializer } from '../serializers/PickListItemSerializer';
import { UpdatePickListItemRequestSerializer } from '../serializers/UpdatePickListItemRequestSerializer';
import { CreatePickListItemRequestSerializer } from '../serializers/CreatePickListItemRequestSerializer';
import { FilterPickListItemRequestSerializer } from '../serializers/FilterPickListItemRequestSerializer';
import { DataviewPickListItemResponseSerializer } from '../serializers/DataviewPickListItemResponseSerializer';
import { Fcb2BProductTypeOptionSerializer } from '../serializers/Fcb2BProductTypeOptionSerializer';
import { FilterFcb2BProductTypeOptionRequestSerializer } from '../serializers/FilterFcb2BProductTypeOptionRequestSerializer';
import { DataviewFcb2BProductTypeOptionResponseSerializer } from '../serializers/DataviewFcb2BProductTypeOptionResponseSerializer';
import { StartFpRoomCreateFileRequestSerializer } from '../serializers/StartFpRoomCreateFileRequestSerializer';
import { StartFpRoomCreateRoomPhotoFileRequestSerializer } from '../serializers/StartFpRoomCreateRoomPhotoFileRequestSerializer';
import { FpRoomSerializer } from '../serializers/FpRoomSerializer';
import { UpdateFpRoomRequestSerializer } from '../serializers/UpdateFpRoomRequestSerializer';
import { CreateFpRoomRequestSerializer } from '../serializers/CreateFpRoomRequestSerializer';
import { FilterFpRoomRequestSerializer } from '../serializers/FilterFpRoomRequestSerializer';
import { DataviewFpRoomResponseSerializer } from '../serializers/DataviewFpRoomResponseSerializer';
import { TaxRatesSerializer } from '../serializers/TaxRatesSerializer';
import { FilterTaxRatesRequestSerializer } from '../serializers/FilterTaxRatesRequestSerializer';
import { DataviewTaxRatesResponseSerializer } from '../serializers/DataviewTaxRatesResponseSerializer';
import { Fcb2BUnderlaymentOptionSerializer } from '../serializers/Fcb2BUnderlaymentOptionSerializer';
import { FilterFcb2BUnderlaymentOptionRequestSerializer } from '../serializers/FilterFcb2BUnderlaymentOptionRequestSerializer';
import { DataviewFcb2BUnderlaymentOptionResponseSerializer } from '../serializers/DataviewFcb2BUnderlaymentOptionResponseSerializer';
import { WasteFactorSerializer } from '../serializers/WasteFactorSerializer';
import { UpdateWasteFactorRequestSerializer } from '../serializers/UpdateWasteFactorRequestSerializer';
import { CreateWasteFactorRequestSerializer } from '../serializers/CreateWasteFactorRequestSerializer';
import { FilterWasteFactorRequestSerializer } from '../serializers/FilterWasteFactorRequestSerializer';
import { DataviewWasteFactorResponseSerializer } from '../serializers/DataviewWasteFactorResponseSerializer';

/**
 * HTTP client for Fcb2B operations
 *
 * Client for Fcb2B operations
 */
export class Fcb2bClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForBomKit(formName: string, objectId: string, createdBy?: string | null, isActive?: boolean | null, parentObjectId?: string | null, parentObjectType?: string | null, tags?: string[] | null, bins?: string[] | null, description?: string | null, name?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.BOMKit({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (bins !== undefined) {
      queryParams.append('Bins', String(bins));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeBomKit(formName: string, createdBy?: string | null, isActive?: boolean | null, parentObjectId?: string | null, parentObjectType?: string | null, tags?: string[] | null, bins?: string[] | null, description?: string | null, name?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.BOMKit/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (bins !== undefined) {
      queryParams.append('Bins', String(bins));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterBomKit(request?: FilterBomKitRequest | null, options?: { headers?: Record<string, string> }): Promise<BomKit[]> {
    const path = '/app/api/Object/fcb2b.BOMKit/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterBomKitRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => BomKitSerializer.fromObject(item));
  }

  async createBomKit(request?: CreateBomKitRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.BOMKit';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateBomKitRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateBomKit(objectId: string, request?: UpdateBomKitRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.BOMKit({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateBomKitRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteBomKit(objectId: string, fields?: BomKitFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<BomKit> {
    let path = '/app/api/Object/fcb2b.BOMKit({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return BomKitSerializer.fromObject(data);
  }

  async recentBomKit(request?: FilterBomKitRequest | null, options?: { headers?: Record<string, string> }): Promise<BomKit[]> {
    const path = '/app/api/Object/fcb2b.BOMKit/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterBomKitRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => BomKitSerializer.fromObject(item));
  }

  async dataViewBomKit(request?: FilterBomKitRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewBomKitResponse> {
    const path = '/app/api/Object/fcb2b.BOMKit/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterBomKitRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewBomKitResponseSerializer.fromObject(data);
  }

  async getFormForBomKitItem(formName: string, objectId: string, createdBy?: string | null, isActive?: boolean | null, tags?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, itemId?: string | null, bomKitId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.BOMKitItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (bomKitId !== undefined) {
      queryParams.append('BOMKitId', String(bomKitId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeBomKitItem(formName: string, createdBy?: string | null, isActive?: boolean | null, tags?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, itemId?: string | null, bomKitId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.BOMKitItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (bomKitId !== undefined) {
      queryParams.append('BOMKitId', String(bomKitId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterBomKitItem(request?: FilterBomKitItemRequest | null, options?: { headers?: Record<string, string> }): Promise<BomKitItem[]> {
    const path = '/app/api/Object/fcb2b.BOMKitItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterBomKitItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => BomKitItemSerializer.fromObject(item));
  }

  async createBomKitItem(request?: CreateBomKitItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.BOMKitItem';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateBomKitItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateBomKitItem(objectId: string, request?: UpdateBomKitItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.BOMKitItem({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateBomKitItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteBomKitItem(objectId: string, fields?: BomKitItemFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<BomKitItem> {
    let path = '/app/api/Object/fcb2b.BOMKitItem({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return BomKitItemSerializer.fromObject(data);
  }

  async recentBomKitItem(request?: FilterBomKitItemRequest | null, options?: { headers?: Record<string, string> }): Promise<BomKitItem[]> {
    const path = '/app/api/Object/fcb2b.BOMKitItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterBomKitItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => BomKitItemSerializer.fromObject(item));
  }

  async dataViewBomKitItem(request?: FilterBomKitItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewBomKitItemResponse> {
    const path = '/app/api/Object/fcb2b.BOMKitItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterBomKitItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewBomKitItemResponseSerializer.fromObject(data);
  }

  async getFormForDiscount(formName: string, objectId: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, flowId?: string | null, isActive?: boolean | null, objectStatusId?: string | null, priceDiscount?: number | null, taxDiscount?: number | null, discountsRatesCategory?: string | null, discountsRatesRate?: number | null, discountsRatesAmount?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.Discount({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (priceDiscount !== undefined) {
      queryParams.append('PriceDiscount', String(priceDiscount));
    }
    if (taxDiscount !== undefined) {
      queryParams.append('TaxDiscount', String(taxDiscount));
    }
    if (discountsRatesCategory !== undefined) {
      queryParams.append('DiscountsRates|Category', String(discountsRatesCategory));
    }
    if (discountsRatesRate !== undefined) {
      queryParams.append('DiscountsRates|Rate', String(discountsRatesRate));
    }
    if (discountsRatesAmount !== undefined) {
      queryParams.append('DiscountsRates|Amount', String(discountsRatesAmount));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeDiscount(formName: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, flowId?: string | null, isActive?: boolean | null, objectStatusId?: string | null, priceDiscount?: number | null, taxDiscount?: number | null, discountsRatesCategory?: string | null, discountsRatesRate?: number | null, discountsRatesAmount?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.Discount/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (priceDiscount !== undefined) {
      queryParams.append('PriceDiscount', String(priceDiscount));
    }
    if (taxDiscount !== undefined) {
      queryParams.append('TaxDiscount', String(taxDiscount));
    }
    if (discountsRatesCategory !== undefined) {
      queryParams.append('DiscountsRates|Category', String(discountsRatesCategory));
    }
    if (discountsRatesRate !== undefined) {
      queryParams.append('DiscountsRates|Rate', String(discountsRatesRate));
    }
    if (discountsRatesAmount !== undefined) {
      queryParams.append('DiscountsRates|Amount', String(discountsRatesAmount));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForEstimateOptions(formName: string, objectId: string, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.EstimateOption({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeEstimateOptions(formName: string, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.EstimateOption/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterEstimateOptions(request?: FilterEstimateOptionsRequest | null, options?: { headers?: Record<string, string> }): Promise<EstimateOptions[]> {
    const path = '/app/api/Object/fcb2b.EstimateOption/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterEstimateOptionsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => EstimateOptionsSerializer.fromObject(item));
  }

  async recentEstimateOptions(request?: FilterEstimateOptionsRequest | null, options?: { headers?: Record<string, string> }): Promise<EstimateOptions[]> {
    const path = '/app/api/Object/fcb2b.EstimateOption/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterEstimateOptionsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => EstimateOptionsSerializer.fromObject(item));
  }

  async dataViewEstimateOptions(request?: FilterEstimateOptionsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewEstimateOptionsResponse> {
    const path = '/app/api/Object/fcb2b.EstimateOption/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterEstimateOptionsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewEstimateOptionsResponseSerializer.fromObject(data);
  }

  async getFormForInstallationTypeOption(formName: string, objectId: string, productType?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.InstallationTypeOption({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeInstallationTypeOption(formName: string, productType?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.InstallationTypeOption/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterInstallationTypeOption(request?: FilterInstallationTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<InstallationTypeOption[]> {
    const path = '/app/api/Object/fcb2b.InstallationTypeOption/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterInstallationTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => InstallationTypeOptionSerializer.fromObject(item));
  }

  async recentInstallationTypeOption(request?: FilterInstallationTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<InstallationTypeOption[]> {
    const path = '/app/api/Object/fcb2b.InstallationTypeOption/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterInstallationTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => InstallationTypeOptionSerializer.fromObject(item));
  }

  async dataViewInstallationTypeOption(request?: FilterInstallationTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewInstallationTypeOptionResponse> {
    const path = '/app/api/Object/fcb2b.InstallationTypeOption/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterInstallationTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewInstallationTypeOptionResponseSerializer.fromObject(data);
  }

  async getFormForPatternTypeOption(formName: string, objectId: string, productType?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PatternTypeOption({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypePatternTypeOption(formName: string, productType?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PatternTypeOption/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterPatternTypeOption(request?: FilterPatternTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<PatternTypeOption[]> {
    const path = '/app/api/Object/fcb2b.PatternTypeOption/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPatternTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PatternTypeOptionSerializer.fromObject(item));
  }

  async recentPatternTypeOption(request?: FilterPatternTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<PatternTypeOption[]> {
    const path = '/app/api/Object/fcb2b.PatternTypeOption/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPatternTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PatternTypeOptionSerializer.fromObject(item));
  }

  async dataViewPatternTypeOption(request?: FilterPatternTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewPatternTypeOptionResponse> {
    const path = '/app/api/Object/fcb2b.PatternTypeOption/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPatternTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewPatternTypeOptionResponseSerializer.fromObject(data);
  }

  async getFormForPaymentTerms(formName: string, objectId: string, discount?: number | null, downPayment?: number | null, downPaymentPercentage?: number | null, frequency?: string | null, installments?: number | null, interestRatePercentage?: number | null, isActive?: boolean | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PaymentTerms({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (discount !== undefined) {
      queryParams.append('Discount', String(discount));
    }
    if (downPayment !== undefined) {
      queryParams.append('DownPayment', String(downPayment));
    }
    if (downPaymentPercentage !== undefined) {
      queryParams.append('DownPaymentPercentage', String(downPaymentPercentage));
    }
    if (frequency !== undefined) {
      queryParams.append('Frequency', String(frequency));
    }
    if (installments !== undefined) {
      queryParams.append('Installments', String(installments));
    }
    if (interestRatePercentage !== undefined) {
      queryParams.append('InterestRatePercentage', String(interestRatePercentage));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypePaymentTerms(formName: string, discount?: number | null, downPayment?: number | null, downPaymentPercentage?: number | null, frequency?: string | null, installments?: number | null, interestRatePercentage?: number | null, isActive?: boolean | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PaymentTerms/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (discount !== undefined) {
      queryParams.append('Discount', String(discount));
    }
    if (downPayment !== undefined) {
      queryParams.append('DownPayment', String(downPayment));
    }
    if (downPaymentPercentage !== undefined) {
      queryParams.append('DownPaymentPercentage', String(downPaymentPercentage));
    }
    if (frequency !== undefined) {
      queryParams.append('Frequency', String(frequency));
    }
    if (installments !== undefined) {
      queryParams.append('Installments', String(installments));
    }
    if (interestRatePercentage !== undefined) {
      queryParams.append('InterestRatePercentage', String(interestRatePercentage));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterPaymentTerms(request?: FilterPaymentTermsRequest | null, options?: { headers?: Record<string, string> }): Promise<PaymentTerms[]> {
    const path = '/app/api/Object/fcb2b.PaymentTerms/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPaymentTermsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PaymentTermsSerializer.fromObject(item));
  }

  async createPaymentTerms(request?: CreatePaymentTermsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.PaymentTerms';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreatePaymentTermsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updatePaymentTerms(objectId: string, request?: UpdatePaymentTermsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.PaymentTerms({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdatePaymentTermsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deletePaymentTerms(objectId: string, fields?: PaymentTermsFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<PaymentTerms> {
    let path = '/app/api/Object/fcb2b.PaymentTerms({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return PaymentTermsSerializer.fromObject(data);
  }

  async recentPaymentTerms(request?: FilterPaymentTermsRequest | null, options?: { headers?: Record<string, string> }): Promise<PaymentTerms[]> {
    const path = '/app/api/Object/fcb2b.PaymentTerms/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPaymentTermsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PaymentTermsSerializer.fromObject(item));
  }

  async dataViewPaymentTerms(request?: FilterPaymentTermsRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewPaymentTermsResponse> {
    const path = '/app/api/Object/fcb2b.PaymentTerms/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPaymentTermsRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewPaymentTermsResponseSerializer.fromObject(data);
  }

  async getFormForPickList(formName: string, objectId: string, createdBy?: string | null, isActive?: boolean | null, parentObjectId?: string | null, parentObjectType?: string | null, tags?: string[] | null, bins?: string[] | null, description?: string | null, name?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PickList({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (bins !== undefined) {
      queryParams.append('Bins', String(bins));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypePickList(formName: string, createdBy?: string | null, isActive?: boolean | null, parentObjectId?: string | null, parentObjectType?: string | null, tags?: string[] | null, bins?: string[] | null, description?: string | null, name?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PickList/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (bins !== undefined) {
      queryParams.append('Bins', String(bins));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterPickList(request?: FilterPickListRequest | null, options?: { headers?: Record<string, string> }): Promise<PickList[]> {
    const path = '/app/api/Object/fcb2b.PickList/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPickListRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PickListSerializer.fromObject(item));
  }

  async createPickList(request?: CreatePickListRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.PickList';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreatePickListRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updatePickList(objectId: string, request?: UpdatePickListRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.PickList({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdatePickListRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deletePickList(objectId: string, fields?: PickListFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<PickList> {
    let path = '/app/api/Object/fcb2b.PickList({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return PickListSerializer.fromObject(data);
  }

  async recentPickList(request?: FilterPickListRequest | null, options?: { headers?: Record<string, string> }): Promise<PickList[]> {
    const path = '/app/api/Object/fcb2b.PickList/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPickListRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PickListSerializer.fromObject(item));
  }

  async dataViewPickList(request?: FilterPickListRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewPickListResponse> {
    const path = '/app/api/Object/fcb2b.PickList/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPickListRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewPickListResponseSerializer.fromObject(data);
  }

  async getFormForPickListItem(formName: string, objectId: string, createdBy?: string | null, isActive?: boolean | null, tags?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, itemId?: string | null, pickListId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PickListItem({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (pickListId !== undefined) {
      queryParams.append('PickListId', String(pickListId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypePickListItem(formName: string, createdBy?: string | null, isActive?: boolean | null, tags?: string[] | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, itemId?: string | null, pickListId?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.PickListItem/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (pickListId !== undefined) {
      queryParams.append('PickListId', String(pickListId));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterPickListItem(request?: FilterPickListItemRequest | null, options?: { headers?: Record<string, string> }): Promise<PickListItem[]> {
    const path = '/app/api/Object/fcb2b.PickListItem/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPickListItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PickListItemSerializer.fromObject(item));
  }

  async createPickListItem(request?: CreatePickListItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.PickListItem';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreatePickListItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updatePickListItem(objectId: string, request?: UpdatePickListItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.PickListItem({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdatePickListItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deletePickListItem(objectId: string, fields?: PickListItemFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<PickListItem> {
    let path = '/app/api/Object/fcb2b.PickListItem({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return PickListItemSerializer.fromObject(data);
  }

  async recentPickListItem(request?: FilterPickListItemRequest | null, options?: { headers?: Record<string, string> }): Promise<PickListItem[]> {
    const path = '/app/api/Object/fcb2b.PickListItem/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPickListItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => PickListItemSerializer.fromObject(item));
  }

  async dataViewPickListItem(request?: FilterPickListItemRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewPickListItemResponse> {
    const path = '/app/api/Object/fcb2b.PickListItem/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterPickListItemRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewPickListItemResponseSerializer.fromObject(data);
  }

  async getFormForfcb2BProductTypeOption(formName: string, objectId: string, code?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.ProductTypeOption({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (code !== undefined) {
      queryParams.append('Code', String(code));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypefcb2BProductTypeOption(formName: string, code?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.ProductTypeOption/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (code !== undefined) {
      queryParams.append('Code', String(code));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterFcb2BProductTypeOption(request?: FilterFcb2BProductTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<Fcb2BProductTypeOption[]> {
    const path = '/app/api/Object/fcb2b.ProductTypeOption/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFcb2BProductTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => Fcb2BProductTypeOptionSerializer.fromObject(item));
  }

  async recentFcb2BProductTypeOption(request?: FilterFcb2BProductTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<Fcb2BProductTypeOption[]> {
    const path = '/app/api/Object/fcb2b.ProductTypeOption/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFcb2BProductTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => Fcb2BProductTypeOptionSerializer.fromObject(item));
  }

  async dataViewFcb2BProductTypeOption(request?: FilterFcb2BProductTypeOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewFcb2BProductTypeOptionResponse> {
    const path = '/app/api/Object/fcb2b.ProductTypeOption/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFcb2BProductTypeOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewFcb2BProductTypeOptionResponseSerializer.fromObject(data);
  }

  async getFpRoomCreateFileForm(objectId: string, contentType?: string | null, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/UserAction(3b1422e4-2f07-4421-8604-4e69cf390639)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (contentType !== undefined) {
      queryParams.append('ContentType', String(contentType));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runFpRoomCreateFileAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/UserAction(3b1422e4-2f07-4421-8604-4e69cf390639)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startFpRoomCreateFile(objectId: string, request?: StartFpRoomCreateFileRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/UserAction(3b1422e4-2f07-4421-8604-4e69cf390639)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartFpRoomCreateFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFpRoomCreateRoomPhotoFileForm(objectId: string, name?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/UserAction(07b45a6f-24ad-4bfb-8456-20cde157cfe4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async runFpRoomCreateRoomPhotoFileAction(objectId: string, request?: DataFormActionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/UserAction(07b45a6f-24ad-4bfb-8456-20cde157cfe4)/DataForm'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(DataFormActionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async startFpRoomCreateRoomPhotoFile(objectId: string, request?: StartFpRoomCreateRoomPhotoFileRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/UserAction(07b45a6f-24ad-4bfb-8456-20cde157cfe4)'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(StartFpRoomCreateRoomPhotoFileRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async getFormForFpRoom(formName: string, objectId: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, usdzRemoteFileId?: string | null, flowId?: string | null, objectStatusId?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, relatedObjects?: Record<string, string> | null, modelRemoteFileId?: string | null, thumbnailRemoteFileId?: string | null, existingSubfloorId?: string | null, removeExistingFloorId?: string | null, furnitureToMoveId?: string | null, appliances?: number | null, bathroomFixtures?: number | null, heavyItemsToMove?: number | null, tags?: string[] | null, perimeterUom?: string | null, perimeterUnits?: number | null, totalAreaUom?: string | null, totalAreaUnits?: number | null, doorsAddTransition?: boolean | null, doorsName?: string | null, doorsTrimDoor?: boolean | null, doorsWallIndex?: number | null, doorsWidthUom?: string | null, doorsWidthUnits?: number | null, doorsIsOpening?: boolean | null, doorsOffset?: number | null, doorsShapeX?: number | null, doorsShapeY?: number | null, doorsShapeZ?: number | null, surfacesArea?: number | null, surfacesName?: string | null, surfacesPerimiter?: number | null, surfacesShapeX?: number | null, surfacesShapeY?: number | null, surfacesShapeZ?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.Room({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (usdzRemoteFileId !== undefined) {
      queryParams.append('UsdzRemoteFileId', String(usdzRemoteFileId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (modelRemoteFileId !== undefined) {
      queryParams.append('ModelRemoteFileId', String(modelRemoteFileId));
    }
    if (thumbnailRemoteFileId !== undefined) {
      queryParams.append('ThumbnailRemoteFileId', String(thumbnailRemoteFileId));
    }
    if (existingSubfloorId !== undefined) {
      queryParams.append('ExistingSubfloorId', String(existingSubfloorId));
    }
    if (removeExistingFloorId !== undefined) {
      queryParams.append('RemoveExistingFloorId', String(removeExistingFloorId));
    }
    if (furnitureToMoveId !== undefined) {
      queryParams.append('FurnitureToMoveId', String(furnitureToMoveId));
    }
    if (appliances !== undefined) {
      queryParams.append('Appliances', String(appliances));
    }
    if (bathroomFixtures !== undefined) {
      queryParams.append('BathroomFixtures', String(bathroomFixtures));
    }
    if (heavyItemsToMove !== undefined) {
      queryParams.append('HeavyItemsToMove', String(heavyItemsToMove));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (perimeterUom !== undefined) {
      queryParams.append('Perimeter|UOM', String(perimeterUom));
    }
    if (perimeterUnits !== undefined) {
      queryParams.append('Perimeter|Units', String(perimeterUnits));
    }
    if (totalAreaUom !== undefined) {
      queryParams.append('TotalArea|UOM', String(totalAreaUom));
    }
    if (totalAreaUnits !== undefined) {
      queryParams.append('TotalArea|Units', String(totalAreaUnits));
    }
    if (doorsAddTransition !== undefined) {
      queryParams.append('Doors|AddTransition', String(doorsAddTransition));
    }
    if (doorsName !== undefined) {
      queryParams.append('Doors|Name', String(doorsName));
    }
    if (doorsTrimDoor !== undefined) {
      queryParams.append('Doors|TrimDoor', String(doorsTrimDoor));
    }
    if (doorsWallIndex !== undefined) {
      queryParams.append('Doors|WallIndex', String(doorsWallIndex));
    }
    if (doorsWidthUom !== undefined) {
      queryParams.append('Doors|Width|UOM', String(doorsWidthUom));
    }
    if (doorsWidthUnits !== undefined) {
      queryParams.append('Doors|Width|Units', String(doorsWidthUnits));
    }
    if (doorsIsOpening !== undefined) {
      queryParams.append('Doors|IsOpening', String(doorsIsOpening));
    }
    if (doorsOffset !== undefined) {
      queryParams.append('Doors|Offset', String(doorsOffset));
    }
    if (doorsShapeX !== undefined) {
      queryParams.append('Doors|Shape|X', String(doorsShapeX));
    }
    if (doorsShapeY !== undefined) {
      queryParams.append('Doors|Shape|Y', String(doorsShapeY));
    }
    if (doorsShapeZ !== undefined) {
      queryParams.append('Doors|Shape|Z', String(doorsShapeZ));
    }
    if (surfacesArea !== undefined) {
      queryParams.append('Surfaces|Area', String(surfacesArea));
    }
    if (surfacesName !== undefined) {
      queryParams.append('Surfaces|Name', String(surfacesName));
    }
    if (surfacesPerimiter !== undefined) {
      queryParams.append('Surfaces|Perimiter', String(surfacesPerimiter));
    }
    if (surfacesShapeX !== undefined) {
      queryParams.append('Surfaces|Shape|X', String(surfacesShapeX));
    }
    if (surfacesShapeY !== undefined) {
      queryParams.append('Surfaces|Shape|Y', String(surfacesShapeY));
    }
    if (surfacesShapeZ !== undefined) {
      queryParams.append('Surfaces|Shape|Z', String(surfacesShapeZ));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeFpRoom(formName: string, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, usdzRemoteFileId?: string | null, flowId?: string | null, objectStatusId?: string | null, parentObjectId?: string | null, parentObjectType?: string | null, relatedObjects?: Record<string, string> | null, modelRemoteFileId?: string | null, thumbnailRemoteFileId?: string | null, existingSubfloorId?: string | null, removeExistingFloorId?: string | null, furnitureToMoveId?: string | null, appliances?: number | null, bathroomFixtures?: number | null, heavyItemsToMove?: number | null, tags?: string[] | null, perimeterUom?: string | null, perimeterUnits?: number | null, totalAreaUom?: string | null, totalAreaUnits?: number | null, doorsAddTransition?: boolean | null, doorsName?: string | null, doorsTrimDoor?: boolean | null, doorsWallIndex?: number | null, doorsWidthUom?: string | null, doorsWidthUnits?: number | null, doorsIsOpening?: boolean | null, doorsOffset?: number | null, doorsShapeX?: number | null, doorsShapeY?: number | null, doorsShapeZ?: number | null, surfacesArea?: number | null, surfacesName?: string | null, surfacesPerimiter?: number | null, surfacesShapeX?: number | null, surfacesShapeY?: number | null, surfacesShapeZ?: number | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.Room/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    if (usdzRemoteFileId !== undefined) {
      queryParams.append('UsdzRemoteFileId', String(usdzRemoteFileId));
    }
    if (flowId !== undefined) {
      queryParams.append('FlowId', String(flowId));
    }
    if (objectStatusId !== undefined) {
      queryParams.append('ObjectStatusId', String(objectStatusId));
    }
    if (parentObjectId !== undefined) {
      queryParams.append('Parent|ObjectId', String(parentObjectId));
    }
    if (parentObjectType !== undefined) {
      queryParams.append('Parent|ObjectType', String(parentObjectType));
    }
    if (relatedObjects !== undefined) {
      queryParams.append('RelatedObjects', String(relatedObjects));
    }
    if (modelRemoteFileId !== undefined) {
      queryParams.append('ModelRemoteFileId', String(modelRemoteFileId));
    }
    if (thumbnailRemoteFileId !== undefined) {
      queryParams.append('ThumbnailRemoteFileId', String(thumbnailRemoteFileId));
    }
    if (existingSubfloorId !== undefined) {
      queryParams.append('ExistingSubfloorId', String(existingSubfloorId));
    }
    if (removeExistingFloorId !== undefined) {
      queryParams.append('RemoveExistingFloorId', String(removeExistingFloorId));
    }
    if (furnitureToMoveId !== undefined) {
      queryParams.append('FurnitureToMoveId', String(furnitureToMoveId));
    }
    if (appliances !== undefined) {
      queryParams.append('Appliances', String(appliances));
    }
    if (bathroomFixtures !== undefined) {
      queryParams.append('BathroomFixtures', String(bathroomFixtures));
    }
    if (heavyItemsToMove !== undefined) {
      queryParams.append('HeavyItemsToMove', String(heavyItemsToMove));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (perimeterUom !== undefined) {
      queryParams.append('Perimeter|UOM', String(perimeterUom));
    }
    if (perimeterUnits !== undefined) {
      queryParams.append('Perimeter|Units', String(perimeterUnits));
    }
    if (totalAreaUom !== undefined) {
      queryParams.append('TotalArea|UOM', String(totalAreaUom));
    }
    if (totalAreaUnits !== undefined) {
      queryParams.append('TotalArea|Units', String(totalAreaUnits));
    }
    if (doorsAddTransition !== undefined) {
      queryParams.append('Doors|AddTransition', String(doorsAddTransition));
    }
    if (doorsName !== undefined) {
      queryParams.append('Doors|Name', String(doorsName));
    }
    if (doorsTrimDoor !== undefined) {
      queryParams.append('Doors|TrimDoor', String(doorsTrimDoor));
    }
    if (doorsWallIndex !== undefined) {
      queryParams.append('Doors|WallIndex', String(doorsWallIndex));
    }
    if (doorsWidthUom !== undefined) {
      queryParams.append('Doors|Width|UOM', String(doorsWidthUom));
    }
    if (doorsWidthUnits !== undefined) {
      queryParams.append('Doors|Width|Units', String(doorsWidthUnits));
    }
    if (doorsIsOpening !== undefined) {
      queryParams.append('Doors|IsOpening', String(doorsIsOpening));
    }
    if (doorsOffset !== undefined) {
      queryParams.append('Doors|Offset', String(doorsOffset));
    }
    if (doorsShapeX !== undefined) {
      queryParams.append('Doors|Shape|X', String(doorsShapeX));
    }
    if (doorsShapeY !== undefined) {
      queryParams.append('Doors|Shape|Y', String(doorsShapeY));
    }
    if (doorsShapeZ !== undefined) {
      queryParams.append('Doors|Shape|Z', String(doorsShapeZ));
    }
    if (surfacesArea !== undefined) {
      queryParams.append('Surfaces|Area', String(surfacesArea));
    }
    if (surfacesName !== undefined) {
      queryParams.append('Surfaces|Name', String(surfacesName));
    }
    if (surfacesPerimiter !== undefined) {
      queryParams.append('Surfaces|Perimiter', String(surfacesPerimiter));
    }
    if (surfacesShapeX !== undefined) {
      queryParams.append('Surfaces|Shape|X', String(surfacesShapeX));
    }
    if (surfacesShapeY !== undefined) {
      queryParams.append('Surfaces|Shape|Y', String(surfacesShapeY));
    }
    if (surfacesShapeZ !== undefined) {
      queryParams.append('Surfaces|Shape|Z', String(surfacesShapeZ));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterFpRoom(request?: FilterFpRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<FpRoom[]> {
    const path = '/app/api/Object/fcb2b.Room/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFpRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => FpRoomSerializer.fromObject(item));
  }

  async createFpRoom(request?: CreateFpRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.Room';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateFpRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateFpRoom(objectId: string, request?: UpdateFpRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.Room({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateFpRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteFpRoom(objectId: string, fields?: FpRoomFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<FpRoom> {
    let path = '/app/api/Object/fcb2b.Room({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FpRoomSerializer.fromObject(data);
  }

  async recentFpRoom(request?: FilterFpRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<FpRoom[]> {
    const path = '/app/api/Object/fcb2b.Room/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFpRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => FpRoomSerializer.fromObject(item));
  }

  async dataViewFpRoom(request?: FilterFpRoomRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewFpRoomResponse> {
    const path = '/app/api/Object/fcb2b.Room/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFpRoomRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewFpRoomResponseSerializer.fromObject(data);
  }

  async getFormForTaxRates(formName: string, objectId: string, city?: string | null, createdOn?: string | null, destination?: boolean | null, postalCode?: string | null, state?: string | null, id?: string | null, taxLiabilitiesAmount?: number | null, taxLiabilitiesCategory?: string | null, taxLiabilitiesDescription?: string | null, taxLiabilitiesName?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.TaxRates({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (destination !== undefined) {
      queryParams.append('Destination', String(destination));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (taxLiabilitiesAmount !== undefined) {
      queryParams.append('TaxLiabilities|Amount', String(taxLiabilitiesAmount));
    }
    if (taxLiabilitiesCategory !== undefined) {
      queryParams.append('TaxLiabilities|Category', String(taxLiabilitiesCategory));
    }
    if (taxLiabilitiesDescription !== undefined) {
      queryParams.append('TaxLiabilities|Description', String(taxLiabilitiesDescription));
    }
    if (taxLiabilitiesName !== undefined) {
      queryParams.append('TaxLiabilities|Name', String(taxLiabilitiesName));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeTaxRates(formName: string, city?: string | null, createdOn?: string | null, destination?: boolean | null, postalCode?: string | null, state?: string | null, id?: string | null, taxLiabilitiesAmount?: number | null, taxLiabilitiesCategory?: string | null, taxLiabilitiesDescription?: string | null, taxLiabilitiesName?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.TaxRates/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (city !== undefined) {
      queryParams.append('City', String(city));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (destination !== undefined) {
      queryParams.append('Destination', String(destination));
    }
    if (postalCode !== undefined) {
      queryParams.append('PostalCode', String(postalCode));
    }
    if (state !== undefined) {
      queryParams.append('State', String(state));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (taxLiabilitiesAmount !== undefined) {
      queryParams.append('TaxLiabilities|Amount', String(taxLiabilitiesAmount));
    }
    if (taxLiabilitiesCategory !== undefined) {
      queryParams.append('TaxLiabilities|Category', String(taxLiabilitiesCategory));
    }
    if (taxLiabilitiesDescription !== undefined) {
      queryParams.append('TaxLiabilities|Description', String(taxLiabilitiesDescription));
    }
    if (taxLiabilitiesName !== undefined) {
      queryParams.append('TaxLiabilities|Name', String(taxLiabilitiesName));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterTaxRates(request?: FilterTaxRatesRequest | null, options?: { headers?: Record<string, string> }): Promise<TaxRates[]> {
    const path = '/app/api/Object/fcb2b.TaxRates/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterTaxRatesRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => TaxRatesSerializer.fromObject(item));
  }

  async recentTaxRates(request?: FilterTaxRatesRequest | null, options?: { headers?: Record<string, string> }): Promise<TaxRates[]> {
    const path = '/app/api/Object/fcb2b.TaxRates/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterTaxRatesRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => TaxRatesSerializer.fromObject(item));
  }

  async dataViewTaxRates(request?: FilterTaxRatesRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewTaxRatesResponse> {
    const path = '/app/api/Object/fcb2b.TaxRates/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterTaxRatesRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewTaxRatesResponseSerializer.fromObject(data);
  }

  async getFormForfcb2BUnderlaymentOption(formName: string, objectId: string, productType?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.UnderlaymentOption({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypefcb2BUnderlaymentOption(formName: string, productType?: string | null, description?: string | null, externalId?: string | null, name?: string | null, id?: string | null, t?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.UnderlaymentOption/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (externalId !== undefined) {
      queryParams.append('ExternalId', String(externalId));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (t !== undefined) {
      queryParams.append('_t', String(t));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterFcb2BUnderlaymentOption(request?: FilterFcb2BUnderlaymentOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<Fcb2BUnderlaymentOption[]> {
    const path = '/app/api/Object/fcb2b.UnderlaymentOption/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFcb2BUnderlaymentOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => Fcb2BUnderlaymentOptionSerializer.fromObject(item));
  }

  async recentFcb2BUnderlaymentOption(request?: FilterFcb2BUnderlaymentOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<Fcb2BUnderlaymentOption[]> {
    const path = '/app/api/Object/fcb2b.UnderlaymentOption/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFcb2BUnderlaymentOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => Fcb2BUnderlaymentOptionSerializer.fromObject(item));
  }

  async dataViewFcb2BUnderlaymentOption(request?: FilterFcb2BUnderlaymentOptionRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewFcb2BUnderlaymentOptionResponse> {
    const path = '/app/api/Object/fcb2b.UnderlaymentOption/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterFcb2BUnderlaymentOptionRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewFcb2BUnderlaymentOptionResponseSerializer.fromObject(data);
  }

  async getFormForWasteFactor(formName: string, objectId: string, productType?: string | null, patternTypeId?: string | null, catalogFeedId?: string | null, itemId?: string | null, styleNumber?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.WasteFactor({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (patternTypeId !== undefined) {
      queryParams.append('PatternTypeId', String(patternTypeId));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeWasteFactor(formName: string, productType?: string | null, patternTypeId?: string | null, catalogFeedId?: string | null, itemId?: string | null, styleNumber?: string | null, name?: string | null, description?: string | null, entityId?: string | null, id?: string | null, createdOn?: string | null, createdBy?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/fcb2b.WasteFactor/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (productType !== undefined) {
      queryParams.append('ProductType', String(productType));
    }
    if (patternTypeId !== undefined) {
      queryParams.append('PatternTypeId', String(patternTypeId));
    }
    if (catalogFeedId !== undefined) {
      queryParams.append('CatalogFeedId', String(catalogFeedId));
    }
    if (itemId !== undefined) {
      queryParams.append('ItemId', String(itemId));
    }
    if (styleNumber !== undefined) {
      queryParams.append('StyleNumber', String(styleNumber));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (createdBy !== undefined) {
      queryParams.append('CreatedBy', String(createdBy));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterWasteFactor(request?: FilterWasteFactorRequest | null, options?: { headers?: Record<string, string> }): Promise<WasteFactor[]> {
    const path = '/app/api/Object/fcb2b.WasteFactor/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterWasteFactorRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => WasteFactorSerializer.fromObject(item));
  }

  async createWasteFactor(request?: CreateWasteFactorRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/fcb2b.WasteFactor';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateWasteFactorRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateWasteFactor(objectId: string, request?: UpdateWasteFactorRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/fcb2b.WasteFactor({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateWasteFactorRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async recentWasteFactor(request?: FilterWasteFactorRequest | null, options?: { headers?: Record<string, string> }): Promise<WasteFactor[]> {
    const path = '/app/api/Object/fcb2b.WasteFactor/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterWasteFactorRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => WasteFactorSerializer.fromObject(item));
  }

  async dataViewWasteFactor(request?: FilterWasteFactorRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewWasteFactorResponse> {
    const path = '/app/api/Object/fcb2b.WasteFactor/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterWasteFactorRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewWasteFactorResponseSerializer.fromObject(data);
  }

}
